import React, { useContext } from 'react'
import LockIcon from '@mui/icons-material/Lock'
import Tooltip from '@mui/material/Tooltip'
import { GlobalContext } from '../../App'

const UpgradeLock = (props) => {
  const { setUpgradeRequired, tenantInfo } = useContext(GlobalContext)
  if (!props.requiredTier || props.requiredTier > tenantInfo.subscriptionTier) {
    return (
      <Tooltip title="Upgrade Required">
        <LockIcon
          sx={{
            fontSize: 18,
            color: props?.color ?? '#bda507',
            cursor: 'pointer',
          }}
        />
      </Tooltip>
    )
  }
}

export default UpgradeLock
